import {
  isInApp,
  bybitHecate,
  formatNumber,
  isApp,
  openOutsideBrowserByApp,
  newTriggerOneLink,
  justFormatNumber,
} from '@web3/base-utils';
import { getScreenType } from '@/hooks/media';
import BigNumber from 'bignumber.js';

export const openBrowserOutOfApp = (url) => {
  bybitHecate('UrlLauncher', 'open', { url, externalApplication: true });
};

export const handleApplyForm = () => {
  const url =
    'https://uponly.larksuite.com/share/base/form/shruskZR9wXqGAJ6jq7PrvTyJUf';

  if (isInApp) {
    openBrowserOutOfApp(url);
    return;
  }

  window.open(url, '_blank');
};

export const isBrowser = typeof window === 'object';

export const shortenString = (str: string, mark = '...') => {
  if (!str) return '--';
  return str.replace(/(.{6}).*(.{4})/, `$1${mark}$2`);
};

export const sliceTableData = (
  list: any[],
  currentPage: number,
  pageSize: number
) => {
  return list.slice((currentPage - 1) * pageSize, currentPage * pageSize);
};

export const formatProjectRank = (num: number | string) => {
  if (Number(num) > 0 && Number(num) < 10) {
    return `0${num}`;
  }
  return num;
};

export const formatMyRank = (num: number | string) => {
  if (Number(num) > 1000) {
    return `1000+`;
  }
  return num;
};

export const formatAmount = (amount: string) => {
  if (new BigNumber(amount).isZero()) {
    return '0';
  }

  return formatNumber(amount, {
    decimal: 2,
    smallNumberValidDigits: 2,
    smallerThanX: 3,
    kmb: false,
    noTrailZero: true,
    roundMode: 7,
  });
};

export const commonOepn = (url: string) => {
  const { isMobile } = getScreenType();

  if (isApp()) {
    openOutsideBrowserByApp(url);
    return;
  }

  if (isMobile) {
    newTriggerOneLink(window.location.href);
    return;
  }

  window.open(url, '_blank');
};

export const muteEmail = (email) => {
  const [localPart, domain] = email.split('@');
  const maskedLocal =
    localPart.length > 2 ? localPart.slice(0, 2) + '***' : localPart[0] + '***';

  return `${maskedLocal}@***`;
};

export const formatAbbreviatedNumber = (num: number) => {
  return formatNumber(num, {
    minKmbUnit: 'M',
    smallNumberValidDigits: 3,
    noTrailZero: true,
    roundMode: BigNumber.ROUND_DOWN,
  });
};
